var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAide(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32 0c-6.329 0-12.516 1.877-17.778 5.393s-9.364 8.514-11.786 14.361c-2.422 5.847-3.056 12.281-1.821 18.489s4.282 11.909 8.758 16.385c4.475 4.475 10.177 7.523 16.384 8.757s12.642 0.601 18.489-1.821c5.847-2.422 10.845-6.523 14.361-11.786s5.393-11.449 5.393-17.778c0-8.487-3.371-16.626-9.373-22.627s-14.141-9.373-22.628-9.373zM30.48 50.52c-0.621 0.059-1.248-0.013-1.84-0.21s-1.136-0.516-1.598-0.936c-0.462-0.42-0.83-0.931-1.083-1.502s-0.383-1.188-0.383-1.812c0-0.624 0.13-1.241 0.383-1.812s0.621-1.083 1.083-1.502 1.006-0.739 1.598-0.936c0.592-0.197 1.219-0.269 1.84-0.21 0.621-0.059 1.248 0.013 1.84 0.21s1.136 0.516 1.598 0.936c0.462 0.42 0.83 0.931 1.083 1.502s0.382 1.188 0.382 1.812c0 0.624-0.13 1.241-0.382 1.812s-0.621 1.082-1.083 1.502c-0.461 0.42-1.006 0.739-1.598 0.936s-1.218 0.269-1.84 0.21zM37.68 30.32c-1.281 0.723-2.397 1.704-3.28 2.88-0.612 1.238-0.836 2.633-0.64 4h-6.92c-0.29-1.756-0.067-3.558 0.643-5.19s1.875-3.024 3.357-4.010c7.56-5.080 4.96-8 4.96-8-2.32-4.6-12.84 0.8-12.84 0.8l-2.76-5.76c19.28-9.28 23 3.32 23 3.32 0.594 2.324 0.37 4.782-0.636 6.96s-2.73 3.944-4.884 5z",
    fill: "#095797"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAide);
export default __webpack_public_path__ + "static/media/aide.045c1fc7e625030dcaf62d1c205592b2.svg";
export { ForwardRef as ReactComponent };